import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e0e5c3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  key: 0,
  class: "tip"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 1,
  class: "logo"
}
const _hoisted_6 = {
  key: 0,
  class: "flex logo cen"
}
const _hoisted_7 = ["src", "height"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "label-title" }
const _hoisted_13 = { class: "form-item" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "label-title" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "form-item" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "label-title" }
const _hoisted_20 = { class: "form-item verifyCode" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "label-title" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "form-item" }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "label-title" }
const _hoisted_27 = { class: "form-item verifyCode" }
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "label-title" }
const _hoisted_30 = {
  key: 2,
  class: "bar"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "line" }
const _hoisted_33 = {
  key: 3,
  class: "platfroms"
}
const _hoisted_34 = ["data-key", "onClickPassive"]
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 4,
  class: "tips1688"
}

import { reactive, ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox, useModal } from 'element-plus'
import { changeLang, t } from '@/plugins/i18n'
import { UserInfo, openAuth2, Plat, platType } from '@/plugins/tripartite-login'
import {
  loginByPwd,
  loginByCode,
  getLoginCode,
  isBind,
  mobileLogin,
  getMobileCode, MobileCodeParams, setDefault
} from '@/apis/login'
import { compTripartitePlatforms, countryType, BizType, CountriesEnum, UseType, getD2dUrl, Site } from '@/common/const'
import LogoSrc from '@/assets/image/icon/logo.png'
import { R, useSite, isJA, isKO } from '@/store'
import { getCountryCodeList } from '@/common/utils'
import { TripartiteUserInfo, UPDATE_TRIPARTITEUSERINFO, REMOVE_TRIPARTITEUSERINFO } from '@/store/modules/tripartite'
import { useGetCode, LoginMode } from './utils'
import { login as createRules } from './rules'
import caches from '@/plugins/cache'

// 机器认证
interface Props {
  h5?: boolean;
  isRam?: boolean;
  hiddenClose?: boolean
  // 详情页登陆
  isDetail?: boolean
}
// 提交表单申明
interface Form {
  nameOrEmail?: string;
  password?: string;
  customerEmail?: string;
  verificationCode?: string;
  customerMobile?: string;
  countryCode?: string;
  nationCode?: string;
  recaptchaCode?: ''; // 谷歌人机密码code
  platformType?: 1; // 1:PC  2: app
  globalRoaming?: string; // 区号
}

/** 手机号前缀 */

export default /*#__PURE__*/_defineComponent({
  props: {
    h5: { type: Boolean },
    isRam: { type: Boolean },
    hiddenClose: { type: Boolean },
    isDetail: { type: Boolean }
  },
  emits: ['onsuccess', 'update:panel'],
  setup(__props: any, { emit }) {

const props = __props as {
  h5?: boolean;
  isRam?: boolean;
  hiddenClose?: boolean
  // 详情页登陆
  isDetail?: boolean
}

const showRecaptcha = ref(false)
const vueRecaptchaRef = ref()
// 获取人机校验接口
const recaptchaVerified = async (res: any) => {
  form.recaptchaCode = res
  const checkResult = await formRef.value.validateField([
    'customerMobile'
  ])
  if (checkResult) {
    const data = { customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: BizType.LOGIN, recaptchaCode: res } as MobileCodeParams
    getPhoneCode(data)
    showRecaptcha.value = false
  }
}
const recaptchaExpired = () => {
  vueRecaptchaRef.value.reset()
}

const mobileAreaCodeOptions = ref<{ value: string; label: string }[]>([])

const loginModeList: { type: LoginMode, name: string }[] = [
  {
    type: LoginMode.password,
    name: t('密码登录')
  },
  {
    type: LoginMode.email,
    name: t('邮箱验证码登录')
  },
  {
    type: LoginMode.phone,
    name: t('手机号验证码登录')
  }
]




const store = useStore<R>()
const router = useRouter()
const route = useRoute()
const site = useSite()
/** 登录Logo */
const loginLogo = ref(LogoSrc)
/** 登录模式 */
const loginMode = ref<LoginMode>(LoginMode.email)
/** 三方授权平台 */
const loginPlatform = ref<string>()
/** 是否授权平台 */
const isNoPlat = computed(() => typeof loginPlatform.value !== 'undefined')
/** 展示密码 */
const showPassWord = ref(false)
/** 三方平台信息 */
const tripartitePlatfromInfo = computed<TripartiteUserInfo>(() => store.state.tripartite)
const loading = ref(false)
const formRef = ref()

// 轮询 返回 true 截止轮训
const createIntervalProlling = (ms: number, timeout: number) => {
  let passMs = 0
  return (handleFunction: () => boolean, prollingEndFunction: (isProllingSuccess: boolean) => void) => {
    const interval = setInterval(() => {
      passMs += ms
      const isProllingSuccess = handleFunction()
      if (isProllingSuccess || passMs >= timeout) {
        clearInterval(interval)
        prollingEndFunction(isProllingSuccess)
      }
    }, ms)
  }
}

const setIntervalProlling = createIntervalProlling(100, 4000)

// setInterval
setInterval
/** 提交表单 */
const form = reactive<Form>({
  nameOrEmail: '',
  password: '',
  customerEmail: '',
  verificationCode: '',
  customerMobile: '',
  recaptchaCode: '', // 谷歌人机密码code
  platformType: 1, // 1:PC  2: app
  countryCode: '+81'
})
/** 站点过滤国家 */
const countries = ref<countryType[]>([])

const {
  count,
  tip,
  disabled,
  getCode,
  getPhoneCode
} = useGetCode('loginCode', getLoginCode, getMobileCode)
/** 发送验证码 */
const sendCode = async () => {
  if (count.value > 0) return
  if (loginMode.value === LoginMode.email) {
    const checkResult = await formRef.value.validateField([
      'customerEmail'
    ])
    if (checkResult) {
      getCode(form.customerEmail as string)
    }
  }
  if (loginMode.value === LoginMode.phone) {
    const checkResult = await formRef.value.validateField([
      'customerMobile'
    ])
    if (checkResult) {
      const data = { customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: BizType.LOGIN } as MobileCodeParams
      getPhoneCode(data)
    }
  }
}

/** 切换登录模式 */
const changeMode = (mode: LoginMode) => {
  loginMode.value = mode
}
/** 切换三方平台信息 */
const changeLoginPlatfrom = (platform: platType) => {
  loginPlatform.value = platform
}
/** 创建提交表单规则 */
const rules = createRules(disabled)

/** 登录接口 */
const _signin = async (form: any, isBind: boolean) => {
  let api: any = loginByPwd
  switch (loginMode.value) {
    case LoginMode.email:
      api = loginByCode
      break
    case LoginMode.password:
      api = loginByPwd
      break
    case LoginMode.phone:
      api = mobileLogin
      break
  }
  // 三方登录强制通过code登录
  if (form.thirdPlatform && form.thirdCustomerId && isBind) {
    api = loginByPwd
  }
  try {
    loading.value = true
    const res = await api({ ...form, globalRoaming: form.countryCode })
    if (res.code === '240300029') {
      ElMessageBox({
        title: 'ACCESS ERROR',
        message: 'US users, please visit SellerStation to access our services. Thank you~',
        confirmButtonText: 'Go to',
        cancelButtonText: 'Cancel',
        type: 'warning',
        showClose: false
      }).then(() => {
        location.href = 'https://sellerstation.com/'
      })
      return
    }
    if (res?.success) {
      store.commit('status/onLogin', false)
      // 第一次注册，选择完平台后
      if (res.data.uuid && !res.data.token) {
        store.commit('route/uuid', res.data.uuid)
        store.commit('route/SET_LOGIN_NAME', form.nameOrEmail)
        // 如果携带直营商城参数登录问题
        if (route.query.from) {
          const res1 = await setDefault({ uuid: res.data.uuid, systemSource: UseType.d2d })
          await store.dispatch('route/setToken', res1.data.token)
          if (res1.success) {
            location.replace(route.query.from as string || getD2dUrl('pc'))
          }
          return
        }
        if (props.h5) {
          router.replace({ name: 'signup_h5' })
        } else {
          router.replace({ name: 'signup' })
        }
      } else {
        // 是否弹出取消订单弹窗
        localStorage.setItem('cancelOrderShow', '0')
        const query = route.query
        const { redirect, from } = query ?? {}
        // 仅日本站带from字段才跳转直营商城/默认登录信息为直营商城
        if (res.data.customerRespDTO.nationCode === CountriesEnum.Japan && from) {
          // 子账号直接登录直营
          if (res.data.customerRespDTO.accountType === 2) {
            await store.dispatch('route/setPlat', res.data.token)
            return false
          }
          await store.dispatch('route/setToken', res.data.token)
          // 保证token已经设置好，跳转到其他工程的时候可以拿到 cookie
          setIntervalProlling(() => {
            console.log('setIntervalProlling', caches.get('route/token'))
            return Boolean(caches.get('route/token'))
          }, () => {
            window.location.replace(decodeURIComponent(from.toString()))
          })
        } else if (redirect) {
          await store.dispatch('route/setToken', res.data.token)
          // window.location.replace(decodeURIComponent(redirect.toString()))
          // 保证token已经设置好，跳转到其他工程的时候可以拿到 cookie
          setIntervalProlling(() => {
            console.log('setIntervalProlling', caches.get('route/token'))
            return Boolean(caches.get('route/token'))
          }, () => {
            window.location.replace(decodeURIComponent(redirect.toString()))
          })
        } else {
          await store.dispatch('route/setPlat', res.data.token)
        }
      }
    } else {
      if (res?.code === '24010003' && form.recaptchaCode) {
        form.recaptchaCode = ''
      }
    }
  } catch (error) {
    console.log(error)
    ElMessage.error(t('登录失败'))
  } finally {
    loading.value = false
  }
}

/** 根据用户是否绑定过CKB，判断直接登录/绑定CKB */
const bindOrLogin = async (info?: UserInfo) => {
  try {
    const res = await isBind({
      thirdPlatform: info?.thirdPlatform,
      thirdCustomerId: info?.thirdCustomerId
    })
    if (res.success) {
      const isbind = res.data?.isBind
      // 已经绑定过我们的账号,直接登录
      if (isbind) {
        _signin({
          thirdPlatform: info?.thirdPlatform as string,
          thirdCustomerId: info?.thirdCustomerId as string
        }, true)
      } else {
        changeLoginPlatfrom(info?.thirdPlatform as Plat)
      }
    }
  } catch (error) {
  }
}

const loginByPlatform = async (platform: Plat) => {
  // 若用户已经授权过某个平台,store中的值等于当前点击的平台，则直接登录
  if (tripartitePlatfromInfo.value.thirdPlatform === platform) {
    bindOrLogin(tripartitePlatfromInfo.value as UserInfo)
    return
  }

  openAuth2(
    {
      plat: platform,
      h5: props.h5
    },
    async (rsp) => {
      bindOrLogin(rsp?.userInfo)
    }
  )
}

const toSignup = () => {
  const path = window.location.href
  // 若当前不是在/login,则应该是切换弹窗
  if (!path.includes('login')) {
    store.commit('status/loginPanel', 'signUp')
  } else {
    // H5直接跳转h5到
    if (props.h5) {
      router.push('/signup_h5' + window.location.search)
    } else {
      router.push('/signup')
    }
  }
}
/** 三方平台绑定登录 */
const bindPlatform = async () => {
  const checkResult = await formRef.value.validate()
  if (!checkResult) return
  if (typeof loginPlatform.value === 'undefined' || loginPlatform.value === '') { return }
  _signin({
    ...form,
    ...tripartitePlatfromInfo.value
  }, false)
}
/** 注册点击 */
const signin = async () => {
  const valid = await formRef.value.validate()
  if (!valid) return
  _signin(form, false)
}

// watch(() => form.countryCode, (val) => {
//   form.countryPlaceCode = countries.value.find(i => i.mobileAreaCode === val)?.key
// }, { immediate: true })

onMounted(() => {
  // if (!store.state.route.curShop) {
  //   store.dispatch('route/setToken', '')
  // }

  if (tripartitePlatfromInfo.value?.thirdPlatform) {
    loginPlatform.value = tripartitePlatfromInfo.value.thirdPlatform
  }
  // 根据语言判断logo
  loginLogo.value = window.location.href.includes('from') ? 'https://static-s.theckb.com/BusinessMarket/Easy/H5/topLogo.png' : 'https://static-jp.theckb.com/static-asset/client/loginLogo.svg'
  if (route.query.from && !isJA()) {
    changeLang('ja')
    localStorage.setItem('countryKey', 'JP')
    store.commit('route/site', 'ja')
    setTimeout(() => {
      location.reload()
    }, 1)
  }

  // 区号列表
  const list = getCountryCodeList()
  countries.value = list
  mobileAreaCodeOptions.value = list.map(i => {
    return {
      label: i.mobileAreaCode,
      value: i.mobileAreaCode
    }
  }).concat({
    label: '—',
    value: ''
  })
  nextTick(() => {
    form.countryCode = list[0].mobileAreaCode
    // form.countryPlaceCode = list[0].key
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNoPlat))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "bind",
            innerHTML: _unref(t)('绑定您的THE CKB账户')
          }, null, 8, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('只需绑定一次，后续可用{platform}直接登录', {
          platform: loginPlatform.value
        })), 1)
        ]))
      : (_openBlock(), _createElementBlock("h3", _hoisted_5, [
          (__props.isDetail)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "login-logo",
                  src: loginLogo.value,
                  alt: "",
                  height: _unref(site) === 'ja' ? 26 : 28
                }, null, 8, _hoisted_7)
              ], 512)), [
                [_vShow, !props.h5]
              ])
            : _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/",
                class: "flex logo cen"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "login-logo",
                    src: loginLogo.value,
                    alt: "",
                    height: "47"
                  }, null, 8, _hoisted_8)
                ]),
                _: 1
              }, 512)), [
                [_vShow, !props.h5]
              ])
        ])),
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: _unref(form),
      rules: _unref(rules)
    }, {
      default: _withCtx(() => [
        (loginMode.value === _unref(LoginMode).password)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('登录名/邮箱')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "nameOrEmail" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _unref(form).nameOrEmail,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).nameOrEmail) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(signin, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('密码')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  prop: "password",
                  id: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: showPassWord.value ? 'text' : 'password',
                      modelValue: _unref(form).password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).password) = $event)),
                      modelModifiers: { trim: true },
                      maxlength: 32,
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (formRef.value.validateField(['password', 'repassword'])))
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(["password-suffix", showPassWord.value
                  ? 'iconfont icon-zhengyan'
                  : 'iconfont icon-biyan'
                  ]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassWord.value = !showPassWord.value))
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["type", "modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (loginMode.value === _unref(LoginMode).phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('手机号登录')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "customerMobile" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "phone",
                      modelValue: _unref(form).customerMobile,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(signin, ["enter"]),
                      maxlength: 50,
                      class: _normalizeClass(props.h5 ? 'phone-input-h5' : 'phone-input')
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "sign-popper-class",
                          class: "countryCode",
                          modelValue: _unref(form).countryCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).countryCode) = $event)),
                          style: {"width":"68px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onKeyup", "class"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('手机验证码')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "verificationCode" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: _unref(form).verificationCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(signin, ["enter"])
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", {
                          type: "text",
                          class: _normalizeClass({
                  getVerifyCode: _unref(count) <= 0,
                  getVerifyCodeDisabled: _unref(count) > 0,
                }),
                          onClick: sendCode
                        }, _toDisplayString(_unref(count) > 0 ? _unref(tip) : _unref(t)('获取验证码')), 3)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (loginMode.value === _unref(LoginMode).email)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('邮箱地址')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "customerEmail" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(form).customerEmail,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).customerEmail) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(signin, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('邮箱验证码')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "verificationCode" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: _unref(form).verificationCode,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(signin, ["enter"])
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", {
                          type: "text",
                          class: _normalizeClass({
                  getVerifyCode: _unref(count) <= 0,
                  getVerifyCodeDisabled: _unref(count) > 0 || _unref(disabled),
                }),
                          onClick: sendCode
                        }, _toDisplayString(_unref(count) > 0 ? _unref(tip) : _unref(t)('获取验证码')), 3)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", null, [
      (_unref(isNoPlat))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            round: props.h5,
            color: "#FF5010",
            class: "next-platform",
            type: "success",
            loading: loading.value,
            onClick: bindPlatform
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确认绑定')), 1)
            ]),
            _: 1
          }, 8, ["round", "loading"]))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            round: props.h5,
            color: "#FF5010",
            class: "next",
            type: "success",
            loading: loading.value,
            onClick: signin
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('登录')), 1)
            ]),
            _: 1
          }, 8, ["round", "loading"]))
    ]),
    (typeof loginPlatform.value === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createVNode(_component_router_link, {
            to: "/login/findpwd",
            class: "forgot-password"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(loginMode.value === _unref(LoginMode).password ? `${_unref(t)('忘记密码')}${!_unref(isKO) ? '?' : ''}` : ''), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", null, [
            _createElementVNode("span", {
              onClick: toSignup,
              class: "to-sign"
            }, _toDisplayString(_unref(t)('去注册')), 1),
            (!props.h5 && !props.isRam)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "to-index"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('首页')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    _withDirectives(_createElementVNode("div", _hoisted_32, null, 512), [
      [_vShow, !props.h5]
    ]),
    (typeof loginPlatform.value === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(compTripartitePlatforms), (platform) => {
            return (_openBlock(), _createElementBlock("div", {
              key: platform.key,
              class: "platform",
              "data-key": platform.key,
              onClickPassive: ($event: any) => (loginByPlatform(platform.key))
            }, [
              _createElementVNode("img", {
                src: platform.logoUrl,
                alt: _unref(t)('平台logo'),
                height: "18",
                width: "18"
              }, null, 8, _hoisted_35)
            ], 40, _hoisted_34))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(loginModeList, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (loginMode.value !== item.type)
          ? (_openBlock(), _createElementBlock("div", {
              class: "change-mode",
              onClick: ($event: any) => (changeMode(item.type)),
              key: item.name
            }, _toDisplayString(item.name), 9, _hoisted_36))
          : _createCommentVNode("", true)
      ], 64))
    }), 64)),
    _withDirectives(_createElementVNode("div", {
      class: "to-sign-platform",
      onClick: toSignup,
      innerHTML: _unref(t)('还没有CKB账户，现在去【注册并绑定】')
    }, null, 8, _hoisted_37), [
      [_vShow, _unref(isNoPlat)]
    ]),
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, "1688による一部の技術サポートサビース"))
      : _createCommentVNode("", true)
  ]))
}
}

})